import React, { useEffect, useState } from 'react'
//Bibliotecas
import { useForm } from 'react-hook-form';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
//Componenentes
import Form from '../../components/common/Form'
import Input from '../../components/common/Input'
import Button from '../../components/common/Button';
import Error from '../../components/common/Error';
import PasswordRecover from './components/PasswordRecover';
//hooks
import useAuth from '../../hooks/useAuth'
//Imágenes
import { LogIn } from 'react-feather';
//Servicios
import preloader from '../../services/Preloader';

export default function Login() {
  //React Hook Form
  const { register, handleSubmit, formState: { errors } } = useForm();
  const { loginError, login, isLogged,user, loading } = useAuth();
  const [recoverModal, setRecoverModal]= useState(false);


  //Manipuladores
  const handleToggleModal = () => {
    setRecoverModal(!recoverModal);
  }

  //Navigate
  const navigate = useNavigate();
  const location = useLocation();
  const fromEstudiante = location.state?.from.pathname || "/home";
  const fromDocente = location.state?.from.pathname || "/homeDocente";

  useEffect(() => {
    preloader();
  }, []);

  //Navegar a la vista home cuando exita un usuario loggeado
  useEffect(() => {
    if (isLogged) {
      if(user?.rol =='estudiante'){
        navigate(fromEstudiante, { replace: true });
      }else{
        navigate(fromDocente, { replace: true });
      }
    }
  }, [isLogged, navigate, user]);

  //Utilizar el servicio de login al enviar formulario
  const onSubmit = (data) => {
    login(data);
  }

  return (
    <>
    <Form onSubmit={handleSubmit(onSubmit)} margin='2% 5%' title='Iniciar sesión' padding='32px 40px' >
      <Input
        label='Correo electrónico'
        name='email'
        placeholder="Ingresa tu correo electrónico"
        register={register}
        required={{ required: "Por favor ingresa tu correo", pattern: { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, message: "Correo electrónico no válido" } }}
        error={errors.email} />

      <Input
        label='Contraseña'
        name='password'
        type='password'
        placeholder="Ingresa tu contraseña"
        register={register}
        required={{ required: "Por vafor ingresa tu contraseña"}}
        error={errors.password} />
        <ForgotPassword onClick={handleToggleModal}><a href='#'>¿Olvidaste tu contraseña?</a> </ForgotPassword>
        

      <Button type='submit' margin='24px 0' loading={loading}><LogIn />Ingresar</Button>
      <Error message={loginError} success></Error>
      <span>¿No tienes una cuenta? <NavLink to='/registro'>Registrarse</NavLink></span>
    </Form>
    <PasswordRecover recoverModal={recoverModal}  setRecoverModal={setRecoverModal} su></PasswordRecover>
    </>
  )
}

const ForgotPassword = styled.small`
    width:90%;
    text-align:right;
`;